/**
 * @file 提示弹窗通用封装入口
 * @author fightingliu
 * @created 2022.04.24
 * @modify 2022.04.24
 */
import _ from 'lodash';
import React, { forwardRef } from 'react';
import SuccessIcon from 'images/app/success.svg';
import FailIcon from 'images/app/fail.svg';
import '../index.scss';

const NoticeDialog: (props: any, ref: any) => JSX.Element = (props: any) => {
  const { type, title, content } = _.get(props, 'payload', {});
  return (
    <div className="notice-dialog">
      <img src={type === 'success' ? SuccessIcon : FailIcon} alt="" className="notice-icon" />
      <div className="notice-title">{title}</div>
      <div className="notice-content">{content}</div>
    </div>
  );
};
export default forwardRef(NoticeDialog);
